import styled from "styled-components";
import { PrimaryButton } from "components/Button/style";

export const ObservacaoLinha = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 20px;
`;

export const InputWrapper = styled.div`
  flex: 1;
  display: grid;
  gap: 4px;
`;

export const SalvarButton = styled(PrimaryButton)`
  width: 90px;
  height: 38px;
  flex-shrink: 0;
`;

export const TabelaHistorico = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;

  th,
  td {
    border: 1px solid #e5e7eb;
    padding: 10px 12px;
    text-align: left;
    vertical-align: top;
  }

  th {
    background-color: #f9fafb;
    font-weight: 600;
    color: #374151;
  }

  tbody tr:nth-child(even) td {
    background-color: #f3f4f6;
  }

  tbody tr:nth-child(odd) td {
    background-color: #ffffff;
  }
`;

export const TabelaWrapper = styled.div`
  max-height: 320px;
  overflow-y: auto;
`;

export const SemRegistros = styled.div`
  text-align: center;
  color: #9ca3af;
  padding: 24px 0;
`;

export const ContainerFechar = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
